import { ICommonBonus } from 'config/types/bonus'
import { UserBonus } from 'config/types/bonus/userBonus'

import AlchemyModal, { ModalBody, ModalFooter, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import { useUserTotalBalance } from 'hooks/useUserTotalBalance'
import { RowCenter } from 'layout/Components/Row'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import RedeemBonusAction from 'views/FreeBonuses/components/RedeemBonusAction'
import BonusDetailsAction from './BonusDetailsAction'
import BonusDetailsContent from './BonusDetailsContent'

const MODAL_COLOR_THEME = 'darkblue'
interface BonusDetailModalProps {
  isRedeemed?: boolean
  isClaimable?: boolean
  isExpired?: boolean
  bonus: ICommonBonus
  actionContent?: string
  percent?: number
  onBonusUpdate?: (bonus: UserBonus) => void
  onRedeemBonus?: () => Promise<boolean>
  ActionButton?: React.ReactNode
}

const BonusDetailsModal: React.FC<ModalProps<BonusDetailModalProps>> = ({ data, onDismiss }) => {
  const { t } = useTranslation()
  const { onBonusUpdate = () => {}, bonus, onRedeemBonus, percent = 0 } = data
  const [bonusInstance, setBonusInstance] = useState({ instance: bonus })

  const userTotalBalance = useUserTotalBalance()
  const minBalanceToRedeem = bonus?.condition?.minBalanceToRedeem

  return (
    <StyledModal onDismiss={onDismiss} colorTheme={MODAL_COLOR_THEME}>
      <ModalHeader title={t('Bonus Details')} colorTheme={MODAL_COLOR_THEME} />

      <ModalBody overflowX="hidden" position="relative">
        <BonusDetailsContent bonus={bonusInstance.instance} />
      </ModalBody>
      <ModalFooter>
        {data?.ActionButton || (
          <>
            {bonusInstance.instance instanceof UserBonus ? (
              <BonusDetailsAction
                bonus={bonusInstance.instance}
                setBonusInstance={setBonusInstance}
                onDismiss={onDismiss}
                onBonusUpdate={onBonusUpdate}
              />
            ) : (
              onRedeemBonus && (
                <StyledBonusAction width="100%">
                  <RedeemBonusAction
                    redeemBonus={onRedeemBonus}
                    isRedeemed={data?.isRedeemed}
                    isClaimable={data?.isClaimable}
                    isExpired={data?.isExpired}
                    percent={percent}
                    isNotEnoughBalanceRequirement={minBalanceToRedeem > 0 && userTotalBalance.lt(minBalanceToRedeem)}
                  />
                </StyledBonusAction>
              )
            )}
          </>
        )}
      </ModalFooter>
    </StyledModal>
  )
}

const StyledModal = styled(AlchemyModal)`
  ${({ theme: { mediaQueries } }) => mediaQueries.sm} {
    min-height: 576px;
  }
  max-width: 420px;
`

const StyledBonusAction = styled(RowCenter)`
  button {
    height: 44px !important;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    max-width: 292px;

    &:disabled {
      background: #1d2533 !important;
    }
  }
`

export default BonusDetailsModal
